<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-calendar-edit" inline title="Edit calendar">
        <v-card-actions>
          <router-link :to="{ name: 'eventCalendarList' }">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
          </router-link>
        </v-card-actions>
        <v-card flat class="px-2">
          <form @submit.prevent="save">
            <v-row>
              <v-col v-if="this.eventColorID !== 2" cols="12" md="6">
                <label class="body-2 font-weight-medium"> Title <span class="error--text">*</span></label>
                <v-text-field class="my-0 py-1" placeholder="Event Title" single-line v-model.trim="title" required></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label class="body-2 font-weight-medium"> {{ titles }} <span class="error--text">*</span></label>
                <v-text-field class="my-0 py-1" single-line placeholder="Event titles" v-model.trim="subtitle" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="8">
                <label class="body-2 font-weight-medium">Description </label>
                <v-textarea rows="3" placeholder="Write Description" clearable v-model.trim="discription" clear-icon="mdi-close-circle" single-line class="my-0 py-1"></v-textarea>
              </v-col>
              <v-col cols="12" lg="4" md="6" v-if="dropFile1.length < 1 && this.eventColorID === 3">
                <label class="label">
                  Select File
                </label>
                <v-file-input :messages="['(max file size allowed 20MB)']" class="my-0 py-1" v-model="dropFile" accept="image/*" @input="onFilechange()" show-size placeholder="Click to Upload">
                </v-file-input>
              </v-col>
              <v-col cols="12" v-if="dropFile1.length > 0">
                <label class="accent--text">Already Uploaded Documents</label>
                <div class="mt-2" rounded="lg" v-for="(file, i) in dropFile1" :key="i">
                  <v-btn elevation="1" class="mr-2" small default @click="download(file.urlPath)">
                    <v-icon left color="primary">mdi-download</v-icon>
                    {{ file.name }}
                  </v-btn>
                  <v-btn elevation="1" small @click="deleteDropFile1(file.id)">
                    <v-icon color="error">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12">
                <v-card-actions class="d-flex justify-end">
                  <v-btn elevation="1" type="submit" color="primary" :disabled="hasClicked">
                    <v-icon left> mdi-content-save </v-icon>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
        </v-card>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import Utils from '@/utils'
export default {
  name: 'editCalendar',
  props: ['calendarID'],
  components: {
    MaterialCard
  },
  data () {
    return {
      total: 0,
      dropFile: [],
      discription: '',
      type: '',
      title: '',
      fromDate: '',
      toDate: '',
      subtitle: '',
      typeData: [],
      annonceData: [],
      eventColorID: '',
      hasClicked: false,
      loader: true,
      sendData: {},
      titles: '',
      selectedfranchiseeID: [],
      dropFile1: [],
      documentData: [],
      isWrite: false,
      isLoading: false,
      deleteFileIdArr: []
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.calendar()
    await this.announcementDocuments()
  },
  methods: {
    calendar: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/communication/eventCalender/${this.calendarID}`)
        this.annonceData = data

        this.eventColorID = this.annonceData.eventColorID
        this.title = this.annonceData.title
        this.subtitle = this.annonceData.subTitle
        this.discription = this.annonceData.descriptions
        if (this.annonceData.eventColorID === 2) {
          this.titles = 'Any Message'
        } else {
          this.titles = 'Sub Title'
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    announcementDocuments: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/communication/eventCalender/${this.calendarID}`)
        this.documentData = data
        this.dropFile1 = this.documentData.eventDocumentsMaps
        if (this.dropFile1) {
          this.dropFile1.forEach(docID => {
            docID.name = docID.urlKey.substring(docID.urlKey.lastIndexOf('/') + 1)
          })
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    deleteDropFile (i) {
      this.dropFile = [this.dropFile]
      this.dropFile.splice(0, 1)
    },
    deleteDropFile1 (docID) {
      this.$buefy.dialog.confirm({
        title: 'Deleting Image',
        message: '"Do you want to Delete this file"?',
        confirmText: 'Delete Image',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.dropFile1.forEach(element => {
            if (docID === element.id) {
              var index = this.dropFile1.indexOf(element)
              if (index !== -1) {
                this.dropFile1.splice(index, 1)
              }
              this.deleteFileIdArr.push(docID)
            }
          })
        }
      })
    },

    save: async function () {
      if (this.deleteFileIdArr.length > 0) {
        this.deleteFileIdArr.forEach(docID => {
          this.deleteDocument(docID)
        })
      }
      let formData = new FormData()
      formData.append('title', this.title)
      formData.append('subTitle', this.subtitle)
      formData.append('descriptions', this.discription)
      formData.append('file', this.dropFile)
      this.hasClicked = true
      try {
        this.isLoading = true
        await http.put(`${constants.API_URL}/api/communication/eventCalender/${this.calendarID}`, formData)
        this.loader = false
        this.isLoading = false
        this.$router.push({ name: 'eventCalendarList' })
        return this.$dialog.info({
          text: 'Saved successfully',
          title: 'Success',
          icon: 'mdi-check'
        })
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    download: async function (i) {
      try {
        let url = await http.get(`${constants.API_URL}/api/staff/downloadurl?s3urlKey=${i}`)
        window.open(url.data)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    deleteDocument: async function (deldocID) {
      try {
        this.isLoading = true
        await http.get(`${constants.API_URL}/api/communication/eventCalender/document/status/${deldocID}`)
        this.isLoading = false
        // this.announcementDocuments()
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    onFilechange () {
      if (this.dropFile.type !== 'image/jpeg' && 'image/jpg' && 'image/png') {
        this.dropFile.pop()
        return this.$dialog.error({
          text: 'please select jpeg , jpg , png format only',
          title: 'Error'
        })
      }
    }
  }
}
</script>
